import React from "react";
import Select from "react-select";
import { Button } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

import { LineInput } from "components/Inputs/LineInput";

import InteractionGraphContainer from "containers/Dataset/InteractionGraph";
import ClusterChartContainer from "containers/ClusterChart/ClusterChart";

import styles from "./style.module.css";

export const TRANSFORM_TYPE_MAP = {
  LogTransform: "Log Transform",
  SquareRootTransform: "Square Root Transform",
  ReciprocalTransform: "Reciprocal Transform",
  TimeTrendTransform: "Extract Trend",
  MonthlySeasonalityTransform: "Extract Monthly Pattern",
  WeekdaySeasonalityTransform: "Extract Weekly Pattern",
  DocumentTransform: "Text to Vector",
  ImageTransform: "Image to Vector",
  SentimentTransform: "Extract Sentiment Score",
  ImageTextTransform: "Image to Text to Vector"
};

export default class Transform extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isCluster: false };
  }

  /* Hacky bugfix for the cluster graph right panel */
  componentDidUpdate(prevProps, prevState) {
    const { isCluster, isInteractionGraph } = this.state;
    if (
      isCluster === true &&
      isInteractionGraph === true &&
      prevState.isCluster === true &&
      prevState.isInteractionGraph === false
    ) {
      this.setState({ isCluster: false });
      setTimeout(() => {
        this.setState({ isCluster: true });
      }, 1);
    }
  }

  renderField(field) {
    const {
      isMini,
      isSmall,
      columnOptions,
      deleteTransform,
      updateFieldOne,
      updateFieldTwo,
      updateOperation,
      updateSaved
    } = this.props;

    return (
      <div
        className={isSmall ? styles.smallCalcField : isMini ? styles.miniCalcField : styles.calcField}
        key={field.id}
      >
        <div className={isMini ? styles.miniCalcColumn : styles.calcColumn}>
          <Select
            value={field.fieldOne}
            onChange={(value) => updateFieldOne(field.id, value)}
            options={columnOptions}
            className={styles.outcomePicker}
            placeholder="First Column"
            menuPlacement="top"
          />
        </div>
        <div className={isMini ? styles.miniCalcColumn : styles.calcColumn}>
          <Select
            value={field.operation}
            onChange={(value) => updateOperation(field.id, value)}
            options={[
              { value: "+", label: "+" },
              { value: "-", label: "-" },
              { value: "*", label: "*" },
              { value: "/", label: "/" }
            ]}
            className={styles.outcomePicker}
            placeholder="Operation"
            menuPlacement="top"
          />
        </div>
        <div className={isMini ? styles.miniCalcColumn : styles.calcColumn}>
          <Select
            value={field.fieldTwo}
            onChange={(value) => updateFieldTwo(field.id, value)}
            options={columnOptions}
            className={styles.outcomePicker}
            placeholder="Second Column"
            menuPlacement="top"
          />
        </div>
        <div className={isMini ? styles.miniCalcColumn : styles.calcColumn}>
          <Button
            type="secondary"
            active={!field.saved}
            disabled={field.operation === undefined || field.fieldOne === undefined || field.fieldTwo === undefined}
            onClick={() => updateSaved(field.id, !field.saved)}
          >
            {field.saved ? "Edit" : "Save"}
          </Button>
          <Button type="secondary" style={{ marginLeft: "10px" }} onClick={() => deleteTransform(field.id)}>
            {"Remove"}
          </Button>
        </div>
      </div>
    );
  }

  renderConcatField(field, index) {
    const {
      isMini,
      isManual,
      isSense,
      fields,
      fieldsObj,
      deleteTransform,
      updateFieldOne,
      updateFieldTwo,
      updateOperation,
      updateColumnLabel,
      updateSaved
    } = this.props;

    const firstField = field && fieldsObj && field.fieldOne ? fieldsObj[field.fieldOne.label] : undefined;
    const secondField = field && fieldsObj && field.fieldTwo ? fieldsObj[field.fieldTwo.label] : undefined;

    const hasTextField =
      (firstField && firstField.type === "categorical" && !firstField.isNumeric) ||
      (secondField && secondField.type === "categorical" && !secondField.isNumeric);

    const isNumericOperation =
      field && field.operation && field.operation.label !== "Interaction" && field.operation.label !== undefined;

    return (
      <div className={styles.tFlex}>
        <div className={styles.tCol}>
          <div
            className={
              isSense
                ? styles.calcFieldSense
                : isManual
                  ? styles.mCalcField
                  : isMini
                    ? styles.miniCalcField
                    : styles.calcField
            }
            key={field.id}
            style={{ opacity: field.saved ? 1.0 : 0.5 }}
          >
            {isSense !== true && (
              <div className={styles.checkboxHolder}>
                <input
                  type="checkbox"
                  checked={field.saved === true}
                  onChange={() => updateSaved(field.id, !field.saved)}
                />
              </div>
            )}
            <div className={isSense ? styles.senseCol : isMini ? styles.miniCalcColumn : styles.calcColumn}>
              <Select
                value={field.fieldOne}
                onChange={(value) => updateFieldOne(field.id, value)}
                options={fields
                  .filter((f) => f.type === "number" || f.isNumeric)
                  .map((f) => ({
                    label: f.label,
                    value: f.label
                  }))}
                className={styles.outcomePicker}
                placeholder="First Column"
                menuPlacement={isSense ? "bottom" : isMini || isManual ? "bottom" : "top"}
              />
            </div>
            <div
              className={isSense ? styles.senseCol : isMini ? styles.miniCalcColumn : styles.calcColumn}
              style={isSense ? {} : { maxWidth: "100px", minWidth: "100px" }}
            >
              {hasTextField ? (
                "Interaction"
              ) : (
                <Select
                  value={field.operation}
                  onChange={(value) => updateOperation(field.id, value)}
                  options={[
                    { value: "+", label: "+" },
                    { value: "-", label: "-" },
                    { value: "*", label: "*" },
                    { value: "/", label: "/" }
                    //{ value: "CONCAT", label: "Interaction" },
                  ]}
                  className={styles.outcomePicker}
                  placeholder="Operation"
                  menuPlacement={isMini || isManual ? "bottom" : "top"}
                />
              )}
            </div>
            <div className={isSense ? styles.senseCol : isMini ? styles.miniCalcColumn : styles.calcColumn}>
              <Select
                value={field.fieldTwo}
                onChange={(value) => updateFieldTwo(field.id, value)}
                options={fields
                  .filter((f) => f.type === "number" || f.isNumeric)
                  .map((f) => ({
                    label: f.label,
                    value: f.label
                  }))}
                className={styles.outcomePicker}
                placeholder="Second Column"
                menuPlacement={isSense ? "bottom" : isMini ? "bottom" : "top"}
              />
            </div>
          </div>
          <LineInput
            placeholder={"New Column Label"}
            onChange={(val) => updateColumnLabel(field.id, val)}
            value={field?.columnLabel}
          />
        </div>
        <div className={isSense ? styles.senseColDel : isMini ? styles.miniCalcColumn : styles.calcColumn}>
          <Button type="secondary" style={{ padding: "7px" }} onClick={() => deleteTransform(field.id)}>
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </div>
      </div>
    );
  }

  renderInteractionGraph() {
    const { id, interactions } = this.props;
    const { isInteractionGraph, isCluster } = this.state;

    return (
      <div
        className={styles.transformContainer}
        style={{
          height: isInteractionGraph ? "500px" : "0px",
          width: isInteractionGraph && isCluster ? "50%" : isInteractionGraph ? "100%" : "0%"
        }}
      >
        <InteractionGraphContainer id={id} />
      </div>
    );
  }

  renderAuto() {
    const { dataset, dataTransforms, addDataTransform, removeDataTransform } = this.props;

    const existingTransforms = dataTransforms ? dataTransforms.map(JSON.stringify) : [];

    return (
      <div className={styles.autoFields}>
        <div className={styles.aBody}>
          <div className={styles.aRow}>
            <div className={styles.aCol} style={{ fontWeight: "bold", marginTop: "10px" }}>
              {"Aible Suggested Fields"}
            </div>
            <div className={styles.aCol}></div>
          </div>

          {dataset &&
            dataset.suggested_features &&
            dataset.suggested_features.map((field, i) => {
              const name =
                field && field.choices && field.choices.length > 0 ? field.choices[0].variable : "Field Name";

              return (
                <div key={i}>
                  <div className={styles.aRow} style={{ marginTop: "20px" }}>
                    <div className={styles.aCol} style={{ fontWeight: "bold" }}>
                      {name}
                    </div>
                    <div className={styles.aCol}></div>
                  </div>
                  {field &&
                    field.choices &&
                    field.choices
                      .filter((c) => TRANSFORM_TYPE_MAP[c.type] !== undefined)
                      .map((c, j) => {
                        const isChecked = existingTransforms.includes(JSON.stringify(c));

                        return (
                          <div className={styles.aRow} key={j}>
                            <div className={styles.aCol}>
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => (isChecked ? removeDataTransform(c) : addDataTransform(c))}
                              />
                              {TRANSFORM_TYPE_MAP[c.type] || c.type}
                            </div>
                          </div>
                        );
                      })}
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  render() {
    const { isMini, id, addField, addInteractions, interactions, options, transform, isManual } = this.props;

    const retTransform =
      transform && transform.length > 0
        ? transform
        : [
            {
              fieldOne: undefined,
              fieldTwo: undefined,
              id: 0,
              operation: undefined,
              saved: true
            }
          ];

    const { isCluster, selected, isInteractionGraph } = this.state;
    const hasInteractions = interactions && interactions.length > 0;
    const isLocked = options && options["lock"];
    const hasMoreInteractions = interactions && retTransform && interactions.length > retTransform.length;

    return (
      <div className={isManual ? styles.mTransform : styles.transform}>
        {isManual !== true && this.renderAuto()}
        {isMini !== true && isManual !== true && <div style={{ marginTop: "20px" }}>{"Calculated Fields"}</div>}
        <div className={styles.fields}>{retTransform.map((field, i) => this.renderConcatField(field, i))}</div>
        {isManual === true && (
          <div
            className={styles.mHeader}
            style={{
              fontSize: "14px",
              color: "#868595",
              fontWeight: 300
            }}
          >
            {"Add New Field"}
          </div>
        )}
        <div className={isMini ? styles.miniIndent : styles.nIndent}>
          {isLocked !== true && (
            <Button type="secondary" onClick={() => addField()} style={{ marginRight: "10px" }}>
              <span>{isMini ? "Add New Variable" : ""}</span>
              <FontAwesomeIcon icon={faPlus} />
            </Button>
          )}
          {hasInteractions && !isLocked && (
            <Button type="secondary" disabled={!hasMoreInteractions} onClick={() => addInteractions()}>
              {hasMoreInteractions ? "Automatically Add Interactions" : "No Additional Interactions"}
            </Button>
          )}
        </div>
      </div>
    );
  }
}
